'use strict';

const FieldTextBoxModel = require('components/ui/field_text_box/js/model');

const validateCvv = (validLength, cvv) => {
    if (!cvv) {
        return 'empty';
    }
    const cvvRegExp = new RegExp('^\\d{' + validLength + '}$');
    if (!cvvRegExp.test(cvv)) {
        return 'invalid';
    }
};

module.exports = FieldTextBoxModel.extend({
    setValidationRegExp: () => {},
    initialize() {
        this.name = 'cvv2';
        FieldTextBoxModel.prototype.initialize.call(this);
    },
    setValidLength(length, options) {
        options = Odigeo._.extend(Odigeo._.isEmpty(this.get('value')) ? {} : {validate: true}, options);
        const attrs = Odigeo._.extend({}, this.toJSON(), {
            validLength: length,
        });
        this.setAttrs(attrs, options);
    },
    update(data) {
        const validLengthData = Odigeo._.isNumber(data.ccvLimit) ? {
            validLength: data.ccvLimit,
        } : {};
        this.set(Odigeo._.extend(validLengthData, {
            value: data.cvv2,
        }));
    },
    validate(attrs = this.toJSON()) {
        if (!attrs.validLength) {
            return;
        }
        return validateCvv(attrs.validLength, attrs.value);
    },
    save() {},
    fetch() {},
});
